var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');

// Actions
var JobActions = require('../actions/job_actions');

// Stores
var JobStore = require('../stores/job_store');

// Job Area
module.exports = React.createClass({
	
	mixins: [
    	Reflux.listenTo(JobStore, 'onJobAction'), 
    ],
   
	onJobAction : function(event, data){
	    	
	    if(event === 'toggle_apply_popup'){
	    	if(this.state.show){
		    	this.setState({ show : false });
	    	} else {
		    	this.setState({ show : true });
	    	}	
	    }
	},
	
	getInitialState : function(){
		return {
			show : false
		}
	},
	
	hideApplyPopup : function(){
		JobActions.toggleApplyPopup();
	},
	
	// Render
  	render: function(){
  		
  		var style = {
  			display : (this.state.show) ? 'block' : 'none',
  			height : 0
  		};
  		
  		if(typeof document != 'undefined'){
	  		style.height = $(document).height();
  		}
  		
   		return (<div onTouchEnd={this.hideApplyPopup} onClick={this.hideApplyPopup} style={style} className="apply-popup-bg"></div>);
	}
});
